import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import Painel from "./painel";
import { requestData } from "../services/requests";
import PainelMobile from "./painelMobile";

const Carteiras = ({ 
  isSingleColumn,
  error,
  carteiras,
  setCarteiras,
  getCarteiras,
  activeTab,
  setActiveTab,
  filtragem,
  page,
  limit,
  setPage,
  setLimit,
  totalCount,
  currentFilters
}) => {

  const { role } = JSON.parse(localStorage.getItem("user"));
  const [bloqueio, setBloqueio] = useState(null);
  const isAdmin = role === "administrador";
  const navigate = useNavigate();

  const largura =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  const getUser = useCallback(async () => {
    try {
      const user = await requestData(`/user`);
      setBloqueio(user.bloqueio);
    } catch (error) {
      console.error("Failed to fetch user", error);
    }
  }, []);

  useEffect(() => {
    getUser();
  }, [getUser]);

  useEffect(() => {
    if (bloqueio === true) {
      localStorage.removeItem("user");
      alert("BLOQUEADO!!!");
      navigate("/login");
    }
  }, [bloqueio, navigate]);


  if (largura >= 1000) {
    return (
      <Painel 
        isSingleColumn={isSingleColumn} 
        carteiras={carteiras}
        setCarteiras={setCarteiras}
        isAdmin={isAdmin} 
        getCarteiras={getCarteiras} 
        filtragem={filtragem} 
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        pagination={{ page, limit, setPage, setLimit, totalCount }}
        currentFilters={currentFilters}
      />
    );
  } else {
    return (
      <PainelMobile 
        carteiras={carteiras} 
        setCarteiras={setCarteiras}
        isAdmin={isAdmin} 
        getCarteiras={getCarteiras} 
        filtragem={filtragem}
        activeTab={activeTab}
        pagination={{ page, limit, setPage, setLimit, totalCount }}
        currentFilters={currentFilters}
      />
    );
  }
};

// Validação de tipos das props
Carteiras.propTypes = {
  error: PropTypes.bool.isRequired,
  carteiras: PropTypes.array.isRequired,
  isSingleColumn: PropTypes.bool.isRequired,
  getCarteiras: PropTypes.func.isRequired,
  filtragem: PropTypes.bool.isRequired,
  pagination: PropTypes.shape({
    page: PropTypes.number,
    limit: PropTypes.number,
    setPage: PropTypes.func,
    setLimit: PropTypes.func,
    totalCount: PropTypes.number,
  }),
  currentFilters: PropTypes.object,
};

export default Carteiras;
